import { TextField as BaseTextField } from "@commonlibs";
import clsx from "clsx";
import { TextFieldProps } from "./TextField.types";

function TextField({ className, variant = "outlined", ...rest }: TextFieldProps) {
    return <BaseTextField className={clsx({ [variant.capitalize()]: Boolean(variant) }, className)} {...rest} />;
}

export default TextField;
